import { Component, OnInit, ViewChild } from '@angular/core';
import * as Flexmonster from 'flexmonster';
import { CommonService } from 'src/app/Service/Common.service';
import { DashboardService } from 'src/app/Service/dashboard/dashboard.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-flex-manhour',
  templateUrl: './flex-manhour.component.html',
  styleUrls: ['./flex-manhour.component.css']
})
export class FlexManhourComponent implements OnInit {
  flexmonsterLicense: string = environment.flexLicenseKey;
  private flexData: any;
  public projectId!: number;
  public groupId!: number;
  public newreport: any;
  public flexmonsterHeight = (screen.availHeight - 20);
  @ViewChild('flexManhourGrid') flexManhourGrid: any;
  constructor(private _dashboardService: DashboardService,
    private commonService: CommonService) { }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.callAPI();
  }
  callAPI() {
    this._dashboardService.GetManHourDetails({ projectId: this.projectId, groupId: this.groupId }).subscribe((res: any[]) => {
      this.flexData = res;
      if (this.flexData.length > 0) {
        this.callreportdata();
      }
    });
  }

  callreportdata() {
    this.newreport = {
      "dataSource": {
        dataSourceType: 'json',
        "data": this.flexData
      },
      slice: {
        rows: [
        {
            uniqueName: "Stage"
          },
          {
            uniqueName: "Month"
          }
      
        ],

        // columns: [{
        //   uniqueName: "Stage"
        // },
        // ],
        measures: [ {
          uniqueName: "Planned_ManHours", caption: "Planned ManHours"
        },
        {
          uniqueName: "Actual_ManHours", caption: "Actual ManHours"
        }

        ],
      },
      options: {
        viewType: "charts",
        chart: {
          title: "Manhour Report - DCI",
          type: "stacked column"
        }
      },
      width: "96%",
      height: '95%',
      formats: [{
        // thousandsSeparator: ",",
        // decimalSeparator: ".",
        // decimalPlaces: 2,
        // currencySymbol: "$",
        // currencySymbolAlign: "left",
        nullValue: "",
        textAlign: "left",
        isPercent: false
      }]
    };

    this.flexManhourGrid.flexmonster.setReport(this.newreport);

  }


  createDialogFlexmonster(): void {
    const tempFlexmonster = new Flexmonster({
      container: 'idFMGridCommonDialog',
      licenseKey: this.flexmonsterLicense,
      toolbar: false,
      height: '96%',
      width: '95%',
      customizeCell: (cell: any, data: any) => {

      },
      global: {
        localization: {
          grid: {
            blankMember: ''
          }
        }
      }
    });
    this.flexManhourGrid.flexmonster = tempFlexmonster;
  }

}
